exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html, body {\n  height: 100%;\n  font-size: 14px;\n}\n\n#root {\n  height: 100%;\n  min-height: 100%;\n  background-color: #fff;\n}\n\na {\n  color: #15284b;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/styles/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss"}!./src/styles/index.css
// module chunks = 1